import { mapActions } from 'vuex';

export const MultiWindowMixin = {
  data: () => ({
    vueMultiWindowMixin: {
      isActivated: false,
      active_element: {
        type: 'bla',
        id: 123,
        source: 'blubb',
        project_id: 1234,
      },
      windowData: []
    },
  }),
  watch: {
  },
  computed: {
  },
  methods: {
    ...mapActions('View', [
      'setValue',
    ]),
    /**
     * Opens a new multiWindow Children. Contains logic to check whether a multiWindow already exists and focuses it if necessary. 
     * Uses CTRL+click to force reopen.
     * @param {*} event mouseclick Event
     */
    openMultiWindow(event) {
      // console.log(event);

      let multiwindowLocalStorageString = localStorage.getItem("multiWindow");
      let multiwindowLocalStorage = JSON.parse(multiwindowLocalStorageString);

      // Open multiWindow only if not jet existing or forced with CTRL+Klick
      // ToDo: Event aus TaktPlanTaktareaDetailsInfo ist noch das widget, nicht das Klick-Event
      if (!event || multiwindowLocalStorage.isActivated === false || event.ctrlKey || event.icon === 'visibility-on') {
        let uniqueId = new Date().getTime(); // Erstellung einer eindeutigen ID

        const currentUrl = window.location.href;
        const urlSegments = currentUrl.split("/");
        let urlPrefix = urlSegments[0] + "//";

        // Durchlaufen der Segmente, um den Prefix bis zum Segment "projects" zu bilden
        for (let i = 2; i < urlSegments.length; i++) {
          urlPrefix += urlSegments[i];
          if (urlSegments[i] === "projects") {
            urlPrefix += "/";
            break;
          }
          urlPrefix += "/";
        }

        let url = `${urlPrefix}${this.$route.params.project_id}/projectstructure?windowId=${uniqueId}`;

        multiwindowLocalStorage.isActivated = true;
        multiwindowLocalStorage.windowData.push({
          id: uniqueId, // Eine eindeutige ID
          modelIsLoading: true // Weitere relevante Daten
        });
        // Speichern des aktualisierten multiWindow-Objekts im LocalStorage
        localStorage.setItem('multiWindow', JSON.stringify(multiwindowLocalStorage));
        // ##########################################

        window.open(url, uniqueId);

        // Test: Mittels Store das Problem umgehen, dass watcher nicht auf hinzugefügte windowData im LocalStorage reagiert
        // Änderung auf View.Store mit Mutation
        this.setValue({ key: 'localStorageMultiWindowUpdated', value: true })
      } else if (multiwindowLocalStorage.isActivated === true && (!event || !event.ctrlKey)) {
        console.log('multiWindow is already active. Trying to Focus on existing multiWindow. Use CTRL+click on the jump button to force reopening.');
        
        // focus on existing multiWindow
        try {
          let multiwindowLocalStorageString = localStorage.getItem("multiWindow");
          let multiwindowLocalStorage = JSON.parse(multiwindowLocalStorageString);
          let latestMultiWindow = Math.max(...multiwindowLocalStorage.windowData.map(window => window.id));
          window.open('', latestMultiWindow).focus();
        } catch (error) {
          console.log(error);
        }
      } else {
        console.log('multiWindow is already active. Use CTRL+click on the jump button to force reopening.');
      }
    },
  },
}